import { useAuth } from '@modules/auth/hooks';
import { PARTICIPANT_RECRUITMENT_LIST_CAMPAIGNS } from '../constants';
import { CAMPAIGN_STATUS } from '../constants/common';
import { fetchCampaigns } from '../services';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { Campaign } from '../services/campaign/campaign.type';

interface ExtendedUseQueryOptions<TError = unknown>
  extends Omit<UseQueryOptions<Campaign[], TError, Campaign[], string[]>, 'initialData' | 'queryFn' | 'queryKey'> {
  status: string;
}

const useQueryListCampaigns = <TError = unknown>(
  options?: ExtendedUseQueryOptions<TError>,
): UseQueryResult<Campaign[]> => {
  const isAuthenticated: boolean = Boolean(useAuth().isAuthenticated);
  const isEnabled: boolean = options?.enabled === undefined ? true : Boolean(options?.enabled);
  const status: string = options?.status ?? CAMPAIGN_STATUS.ACTIVE;
  return useQuery([PARTICIPANT_RECRUITMENT_LIST_CAMPAIGNS, status], async () => await fetchCampaigns(status), {
    ...options,
    enabled: isAuthenticated && isEnabled,
  });
};

export default useQueryListCampaigns;
